import React from 'react';
import { Monitor } from 'lucide-react';
import { getDeviceIcon } from '@/utils/notificationUtils';

interface NotificationToastProps {
  message: string;
  osType?: string;
  type: 'enrolled' | 'removed';
}

export const NotificationToast: React.FC<NotificationToastProps> = ({
  message,
  osType,
  type
}) => {
  return (
    <div className="flex items-center gap-2">
      {type === 'enrolled' ? getDeviceIcon(osType) : <Monitor className="h-5 w-5" />}
      <span>{message}</span>
    </div>
  );
};